// Thème de TOUTE l'application : clair | sombre | système — bouton dans la barre du haut (ThemeToggle).
//
// L'interface d'Amiral Blanc est dessinée en sombre, avec des milliers de couleurs écrites directement dans les composants : il
// n'existe pas de jeu de variables à rebasculer. Le mode clair est donc obtenu en INVERSANT le rendu de la page (filtre CSS sur
// <html>, voir globals.css), puis en ré-inversant ce qui ne doit pas changer de couleur (images, vidéos, cartes, fenêtres Jitsi…).
// Avantage : tout l'écran bascule d'un coup, sans retoucher chaque page. Limite : les teintes sont des approximations de l'original
// sombre, pas une palette claire dessinée à la main.
//
// Valeur par défaut : SOMBRE (l'apparence actuelle) — le clair se choisit, il ne s'impose pas.
// Le choix est un confort du poste (localStorage) ; l'attribut data-app-theme de <html> porte le thème effectivement affiché.

import { parseTheme, resolveTheme, type ThemeChoice } from './dashboard-layout'

export const THEME_KEY = 'ab-theme'
export const THEME_EVENT = 'ab-theme-change'
export const THEME_ATTR = 'data-app-theme'
export const DEFAULT_THEME: ThemeChoice = 'dark'
export const THEME_LABELS: Record<ThemeChoice, string> = { light: 'Clair', dark: 'Sombre', system: 'Système' }
export const THEME_ICONS: Record<ThemeChoice, string> = { light: '☀', dark: '☾', system: '◐' }

/** Choix enregistré, ou le défaut (sombre) : jamais « système » sans que la personne l'ait demandé. */
export const choiceFrom = (stored: string | null | undefined): ThemeChoice => (stored === 'light' || stored === 'dark' || stored === 'system' ? parseTheme(stored) : DEFAULT_THEME)
export { resolveTheme }

/**
 * Posé dans <head> AVANT l'affichage : le thème est appliqué avant la première image, sans éclair sombre → clair.
 * Mêmes règles que choiceFrom/resolveTheme (testé pour qu'elles ne divergent pas).
 */
export const NO_FLASH_SCRIPT = `(function(){try{var c=localStorage.getItem('${THEME_KEY}');var d=window.matchMedia('(prefers-color-scheme: dark)').matches;var r=c==='light'?'light':c==='system'?(d?'dark':'light'):'dark';document.documentElement.setAttribute('${THEME_ATTR}',r);}catch(e){document.documentElement.setAttribute('${THEME_ATTR}','dark');}})();`
